module.exports = __webpack_public_path__ + "img/video_thumb_02.c1890ce0.png";